import React, { Fragment, useEffect, useState } from "react";
import SideBar from "./SideBarStruttura";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import WikiVideoModal from "../../components/Util/WikiVideoModal";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const [showWikiVideo, setShowWikiVideo] = useState(false);
  const onClick = (name) => setToggle(toggle === name ? "" : name);

  useEffect(() => {
    try {
      const tokenDetailsString = sessionStorage.getItem('userDetails');
      if (!tokenDetailsString) return;
      const tokenDetails = JSON.parse(tokenDetailsString);
      const seenKey = `wiki-video-seen-${tokenDetails.localId}`;
      if (!localStorage.getItem(seenKey)) {
        setShowWikiVideo(true);
        localStorage.setItem(seenKey, '1');
      }
    } catch (e) { /* ignore */ }
  }, []);

  return (
    <Fragment>
      <NavHader />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar />
      <WikiVideoModal show={showWikiVideo} onHide={() => setShowWikiVideo(false)} />
    </Fragment>
  );
};

export default JobieNav;
